import { ArrowBackRounded } from "@mui/icons-material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import IconButton from "../../components/ui/IconButton";
import styles from "./css/AuthLayout.module.css";

interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
  description?: ReactNode;
  // 있으면 왼쪽 위에 뒤로가기 버튼을 보여준다
  onBack?: () => void;
  // 로그인 첫 화면처럼 로고 · 소개 문구를 크게 보여줄 때
  hero?: ReactNode;
}

// 로그인 · 회원가입 · 비밀번호 재설정 화면의 공통 틀.
// 모바일은 화면 전체, 태블릿 이상은 가운데 카드로 보여준다.
export default function AuthLayout({
  children,
  title,
  description,
  onBack,
  hero,
}: AuthLayoutProps) {
  const { t } = useTranslation();
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <div className={styles.screen}>
      <main className={styles.card}>
        <div className={styles.top}>
          {onBack ? (
            <IconButton
              aria-label={t("Back")}
              icon={<ArrowBackRounded />}
              className={styles.back}
              onClick={onBack}
            />
          ) : (
            <img
              className={styles.logo}
              src={`${publicUrl}/imgOnevocaLogoBlue.png`}
              alt="onevoca"
            />
          )}
        </div>

        {hero}

        {(title || description) && (
          <div className={styles.heading}>
            {title && <h1 className={styles.title}>{title}</h1>}
            {description && (
              <div className={styles.description}>{description}</div>
            )}
          </div>
        )}

        <div className={styles.body}>{children}</div>
      </main>

      <footer className={styles.footer}>
        <a href="/terms" target="_blank" rel="noreferrer">
          {t("TermsOfUse")}
        </a>
        <span aria-hidden>|</span>
        <a href="/privacy" target="_blank" rel="noreferrer">
          {t("PrivacyPolicy")}
        </a>
      </footer>
    </div>
  );
}
